import React from 'react'
import { Grid } from '@material-ui/core'
import CardLogin from './CardLogin'
import banner from '../image/eduCATImg.svg'

const ContainerLogin = () =>{
  const StyleContainer = {
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    marginTop:'24px',
    padding:'12px 14px',
    backgroundColor: '#F6F6F6',
  }

  return(
    <Grid container>
      <Grid style={StyleContainer} container spacing={3} justifyContent='center' >
        <Grid item xs={12} md={4}><CardLogin/></Grid>
        <Grid item xs={12} md= {8}><img src={banner} alt="Banner" style={{width: '100%',maxHeight: '308px'}}/></Grid>
      </Grid>
    </Grid>
  )
}

export default ContainerLogin;
